import React from 'react';
import { ArrowRight, ShieldCheck, Globe2 } from 'lucide-react';
import { Button } from './ui/button';
import { heroImage } from '../mock/data';
import { useI18n } from '../context/I18nContext';

const Hero = () => {
  const { t } = useI18n();
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${heroImage})` }} />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0b2545]/90 via-[#0b2545]/70 to-[#0b2545]/40" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0b2545] via-transparent to-transparent" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 w-full pt-32 pb-20">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full mb-8">
            <Globe2 className="w-4 h-4 text-[#f7a11a]" />
            <span className="text-white/90 text-xs tracking-[0.2em] uppercase font-medium">{t('hero.badge')}</span>
          </div>

          <h1 className="text-white font-black leading-[0.95] tracking-tight" style={{ fontSize: 'clamp(3rem, 7vw, 6.5rem)' }}>
            {t('hero.title')}
          </h1>

          <p className="mt-8 text-lg lg:text-xl text-slate-200 max-w-2xl leading-relaxed">{t('hero.subtitle')}</p>

          <div className="mt-10 flex flex-wrap gap-4">
            <Button onClick={() => scrollTo('#quote')} className="bg-[#f7a11a] hover:bg-[#e69108] text-slate-900 font-semibold h-14 px-8 rounded-none tracking-wide text-sm group">
              {t('cta.getQuote')} <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button onClick={() => scrollTo('#products')} variant="outline" className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#0b2545] h-14 px-8 rounded-none tracking-wide text-sm font-semibold">
              {t('cta.exploreProducts')}
            </Button>
          </div>

          <div className="mt-16 flex flex-wrap items-center gap-8 pt-8 border-t border-white/20">
            <div className="flex items-center gap-3">
              <ShieldCheck className="w-6 h-6 text-[#f7a11a]" />
              <div>
                <div className="text-white font-semibold text-sm">ISO • BIS • ASTM • CE</div>
                <div className="text-white/60 text-xs">{t('hero.certified')}</div>
              </div>
            </div>
            <div className="h-10 w-px bg-white/20 hidden md:block" />
            <div className="flex items-center gap-3">
              <Globe2 className="w-6 h-6 text-[#f7a11a]" />
              <div>
                <div className="text-white font-semibold text-sm">{t('hero.markets')}</div>
                <div className="text-white/60 text-xs">{t('hero.regionsShort')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden lg:flex flex-col items-center gap-2 text-white/70">
        <span className="text-[10px] tracking-[0.3em] uppercase">{t('hero.scroll')}</span>
        <div className="w-px h-10 bg-white/40 animate-pulse" />
      </div>
    </section>
  );
};

export default Hero;
